<template>
  <div class="megaMenu" v-click-outside="clickOutsideConfig" v-focus-outside="focusOutsideHandler">
    <div @click.capture="focusHandler" @focus.capture="focusHandler" @keydown.up.prevent @keydown.down.prevent ref="mainTarget" :class="{isOpen: isOpen, disabled: disabled}" :tabindex="tabindex ? 0 : -1">
      <slot>
        <div class="input text-grey-darker">
          {{ placeholder }}
        </div>
      </slot>
    </div>
    <transition name="fade">
      <div class="megaDropdown" ref="megaDropdown" v-show="isOpen" :style="menuStyle">
        <ul :class="(this.options && this.options.minWidth) || (this.options && this.options.isBlock) ? 'isBlock': null">
          <slot name="dropdown"></slot>
          <div v-if="isButtons" class="flex items-center justify-end">
            <div class="flex justify-end">
              <button class="btn btn-sm btn-text btn-grey text-sm m-4" @click.capture="onCancel" v-t="'close'"></button>
            </div>
            <div  class="flex justify-end">
              <button class="btn btn-sm btn-text btn-blue text-sm m-4" @click.capture="onConfirm" v-t="'ok'"></button>
            </div>
          </div>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import Modal from './index.js'
export default {
  name: 'megaMenu',
  props: {
    isButtons: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Please select'
    },
    disabled: {
      type: Boolean
    },
    options: {
      type: Object
    },
    tabindex: {
      type: [Number, Boolean],
      default: true
    }
  },
  data () {
    return {
      isOpen: false,
      targetWidth: 0,
      clickOutsideConfig: {
        handler: this.clickOutsideHandler,
        middleware: this.clickOutsideMiddleware
      }
    }
  },
  computed: {
    menuStyle: function () {
      return {
        minWidth: typeof this.targetWidth === 'number' ? this.targetWidth + 'px' : this.targetWidth,
        left: 0
      }
    }
  },
  methods: {
    clickOutsideMiddleware: function (event) {
      // console.debug('Middleware', event)
      return !this.isButtons && this.isOpen
    },
    clickOutsideHandler: function (event) {
      if (!this.clickOutsideMiddleware()) return
      console.debug('clickOutsideHandler', this.clickOutsideMiddleware(), event.target.classList)
      this.closeHandler()
    },
    closeHandler: function () {
      this.isOpen = false
    },
    focusOutsideHandler: function (event) {
      if (Array.isArray(event.path) && event.path[0].nodeName === 'BUTTON') { // 點擊搜尋房源
        this.closeHandler()
      }
    },
    blurHandler: function (e, el) {
      this.closeHandler()
    },
    focusHandler: function () {
      if (!this.disabled) {
        Modal.event.isActivated = this._uid
        this.targetWidth = this.options?.minWidth || this.$refs.mainTarget.clientWidth
        this.isOpen = true
      }
      // if (Modal.event.isActivated !== this._uid) {
      //   console.log(Modal.event.isActivated, this._uid)
      // }
    },
    onCancel: function () {
      this.$emit('cancel')
      // this.closeHandler()
    },
    onConfirm: function () {
      this.$emit('confirm')
      // this.closeHandler()
    }
  },
  updated () {
    // console.log(Modal.event.isActivated, this._uid)
  },
  watch: {
    isOpen: function (val, oldVal) {
      if (val) {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.megaMenu
  @apply relative
  .megaDropdown
    @apply mt-8 absolute z-10
    // right: 0
    &:before
      content: ''
      @apply absolute border-grey-light shadow
      width: 12px
      height: 12px
      top: -6px
      left: 16px
      @apply bg-white
      box-shadow: 2px -2px 1px 0px rgba(0, 0, 0, .03)
      transform: rotate(-45deg)
      z-index: 1
      // border-style: solid
      // border-width: 0 8px 8px 8px
      // border-top-color: transparent
      // border-right-color: transparent
      // border-left-color: transparent
    &:after
      content: ''
      width: 15px
      height: 1px
      @apply bg-white absolute pin-t
      left: 14px
    ul
      @apply bg-white shadow inline-block rounded-sm list-reset border border-grey-lighter
      li
        @apply p-8
  .isOpen
    // @apply shadow-outline rounded
  .disabled
    @apply opacity-50
  .megaDropdown
    transform: translateY(5px)
  .fade-leave
    opacity: 1
  .fade-leave-active
    transition: all ease-out .05s
  .fade-leave-to
    opacity: .5
    transform: translateY(-10px)
  .fade-enter
    opacity: .5
    transform: translateY(-10px)
  .fade-enter-active
    transition: all ease-out .08s
  .fade-enter-to
    opacity: 1
  .isBlock
    @apply block #{!important}
</style>
